// extracted by mini-css-extract-plugin
export default {"tr":"InternalForcesDetails_tr__zxs9Z","tdLeft":"InternalForcesDetails_tdLeft__rh0Bu"};